export enum InsuranceType {
  PRIVATE = 'PRIVATE',
  PRIVATE_AND_PUBLIC = 'PRIVATE_AND_PUBLIC'
}